import SpeechToText1 from './SpeechToText'

function App() {
  return <SpeechToText1 />
}

export default App
